<div class="container client-component" *ngIf="currentClient">
    <div class="row">
        <div class="col-12 p-b-20">
            <div *ngIf="currentClient.isVerificationStale" class="alert alert-warning client-verification-warning" role="alert">
                <div class="d-flex flex-row justify-content-center">
                    <i class="fa fa-exclamation-circle verify-icon me-2"></i>
                    <span class="verify-warning">
                    Expired Verification
                </span>
                </div>
<div class="d-flex w-100 justify-content-center mt-3">
    <span class="text-xs-center">This client's information hasn't been verified in the last {{ verificationStalenessDays$ | async }} days. Please ensure the client record is still accurate, and then click below to confirm.</span>
</div>
                <div class="w-100 d-flex flex-row justify-content-center my-3">
                    <button class="btn client-action-button verify-button me-3 btn-success"
                            tooltip="I have verified that this client's information is accurate and up to date."
                            [class.disabled]="isClientVerified()"
                            (click)="verifyClient()">{{ isClientVerified() ? 'Client Verified' : 'Verify Client' }}</button>
                    <div class="d-flex flex-column">
                        <span class="text-muted small">
                            Last verified date: {{ lastVerifiedOn }}
                        </span>
                        <span class="text-muted small">Last verified by: {{ lastVerifiedByUser }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

  <div class="row">
    <div class="col-12">
      <h4 class="d-inline-block">Overview for: {{currentClient.prefix}} {{currentClient.firstName}}
        {{currentClient.middleInitial}} {{currentClient.lastName}} {{currentClient.suffix}}
        <span *ngIf="currentClient.last4Ssn"><a href="#" (click)="revealSsn.open()">(***-**-{{currentClient.last4Ssn}})</a></span>
        <span *ngIf="!currentClient.last4Ssn">(Missing SSN)</span>
      </h4>
        <div class="d-flex flex-row align-items-center mt-1" *ngIf="!currentClient.isVerificationStale">
            <i class="fa fa-check me-1 text-muted small"></i>
                        <span class="text-muted small">
                            Last verified on {{ lastVerifiedOn }}
                            <span *ngIf="currentClient.lastVerifiedBy">{{' by ' + lastVerifiedByUser }}</span>
                        </span>
        </div>
      <a class="btn btn-primary btn-clientNav client-action-button" [routerLink]="['./edit']">Edit Client</a>
    </div>
  </div>
  <div class="row mt-4">
    <label class="col-md-3"><strong>Address:</strong></label>
    <div class="col-md-8">
      <address>
        {{currentClient.address1}} {{currentClient.address2}}<br>
        {{currentClient.city}}, {{currentClient.state}} {{currentClient.zipCode}}<br>
        <div *ngIf="currentClient.phone" class="my-1">
          <span class="fa fa-phone"></span> {{currentClient.phone}} {{currentClient.phoneExt}}
        </div>
        <div *ngIf="currentClient.email" class="my-1">
          <span class="fa fa-envelope"></span> {{currentClient.email}}
        </div>
      </address>
    </div>
  </div>
  <div class="row">
    <label class="col-md-3"><strong>Personal Information:</strong></label>
    <div class="col-md-8">
        <div class="mb-1">
            <label class="me-2">Gender: </label>
            <span *ngIf="currentClient.gender">{{getGenderLabel(currentClient.gender)}}</span>
            <span *ngIf="!currentClient.gender" class="text-danger">Missing</span> <br>
        </div>

        <div class="my-1">
      <label class="me-2">Race: </label>
      <span *ngIf="currentClient?.race">{{getRaceLabel(currentClient.race)}}</span>
      <span *ngIf="!currentClient?.race" class="text-danger">Missing</span> <br>
        </div>

        <div class="my-1">
      <label *ngIf="currentClient?.otherRace" class="me-2">Other Race:</label>
      <span *ngIf="currentClient?.otherRace">{{currentClient.otherRace}}<br></span>
        </div>

        <div class="my-1">
      <label class="me-2">Birth Year: </label>
      <span *ngIf="currentClient.birthYear">{{currentClient.birthYear}}</span>
      <span *ngIf="!currentClient.birthYear" class="text-danger">Missing</span> <br>
        </div>

        <div class="my-1">
      <label class="me-2">Employment Status: </label>
      <span *ngIf="currentClient.employmentStatus">{{getEmploymentLabel(currentClient.employmentStatus)}}</span>
      <span *ngIf="!currentClient.employmentStatus" class="text-danger">Missing</span> <br>
        </div>

        <div class="my-1">
      <label class="me-2">Poverty Level: </label>
      <span
              *ngIf="hasAValue(currentClient.federalPovertyLevelDisplay)">{{currentClient.federalPovertyLevelDisplay | percent }}</span>
      <span *ngIf="!hasAValue(currentClient.federalPovertyLevelDisplay)" class="text-danger">Missing</span> <br>
        </div>

        <div class="my-1">
      <label class="me-2">Household Size: </label>
      <span *ngIf="currentClient.houseHoldSize">{{currentClient.houseHoldSize}}</span>
      <span *ngIf="!currentClient.houseHoldSize" class="text-danger">Missing</span> <br>
        </div>

        <div class="my-1">
      <label class="me-2">Monthly Household Income: </label>
      <span
              *ngIf="hasAValue(currentClient?.houseHoldIncome)">{{currentClient?.houseHoldIncome | parseNumber | currency:'USD':'symbol':'1.2-2'}}</span>
      <span *ngIf="!hasAValue(currentClient?.houseHoldIncome)" class="text-danger">Missing ({{currentClient.houseHoldIncome}})</span> <br>
        </div>

        <div class="my-1">
      <label class="me-2">Individual Monthly Income: </label>
      <span
              *ngIf="hasAValue(currentClient?.individualMonthlyIncome)">{{currentClient?.individualMonthlyIncome | parseNumber | currency:'USD':'symbol':'1.2-2'}}</span>
      <span *ngIf="!hasAValue(currentClient?.individualMonthlyIncome)" class="text-danger">Missing</span> <br>
        </div>

        <div class="my-1">
      <label class="me-2">Union Info: </label>
      <span>{{currentClient.unionInfo }}</span>
        </div>
    </div>
  </div>
  <br>
  <div class="row">
    <label class="col-md-3"><strong></strong></label>
    <div class="col-md-8">
      <div *ngIf="currentClient.isElderly">
        <span class="fa fa-check-square-o"></span>
        <label>: Client is elderly</label>
      </div>
      <div *ngIf="currentClient.isDisabled">
        <span class="fa fa-check-square-o"></span>
        <label>: Client is disabled</label>
      </div>
      <div *ngIf="currentClient.hasChildrenUnderFive">
        <span class="fa fa-check-square-o"></span>
        <label>: Client has children under five</label>
      </div>
      <div *ngIf="currentClient.isVeteran">
        <span class="fa fa-check-square-o"></span>
        <label>: Client is a veteran</label>
      </div>
      <div *ngIf="currentClient.isHomeless">
        <span class="fa fa-check-square-o"></span>
        <label>: Client is homeless</label>
      </div>
      <div *ngIf="currentClient.membersAreElderly">
        <span class="fa fa-check-square-o"></span>
        <label>: Household members are elderly</label>
      </div>
      <div *ngIf="currentClient.membersAreDisabled">
        <span class="fa fa-check-square-o"></span>
        <label>: Household members are disabled</label>
      </div>
      <div *ngIf="currentClient.membersHaveChildrenUnderFive">
        <span class="fa fa-check-square-o"></span>
        <label>: Household members have children under 5</label>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="isClientVerified() && currentUser.userType == userTypes.SystemAdmin">
    <div class="col-12">
      <button class="btn btn-outline-danger pull-right client-action-button" (click)="prompt.open()">Merge Client</button>
    </div>
  </div>
  <prompt-dialog #f [size]="'lg'" [titleText]="'Search For Client To Merge With'" [showTitle]="true"
                 [promptText]="mergeClientText" [overrideFooter]="true">
    <clientList body (selectedClient)="mergeClient = $event"></clientList>
    <div footer>
      <button class="btn btn-secondary pull-right px-1" (click)="cancelMerge()">Cancel</button>
      <button class="btn btn-danger pull-right px-1 me-1" (click)="mergeClients()" *ngIf="mergeClient">Confirm
      </button>
    </div>
  </prompt-dialog>
  <client-ssn-reveal [clientId]="currentClient.id"></client-ssn-reveal>
</div>
